<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header" style="display: flex;">
      <vxe-button icon="vxe-icon--refresh" @click="refresh">刷新</vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          show-overflow
          stripe
          align="center"
          border="none"
          :loading="loading"
          :data="tableData"
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作" width="50">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" @click="showEdit(row)">编辑</Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="companyName" title="企业名称"></vxe-table-column>
        <vxe-table-column field="userName" title="用户名"></vxe-table-column>
        <vxe-table-column field="password" title="交换密码"></vxe-table-column>
        <vxe-table-column field="publicKey" title="公钥"></vxe-table-column>
        <vxe-table-column field="appId" title="AppID"></vxe-table-column>
        <vxe-table-column field="appSecret" title="AppSecret"></vxe-table-column>
        <vxe-table-column field="hostExchange" title="上传接口url"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="visible" :title="title" width="746" height="700" @close="close" position="center">
      <report-comp-detail ref="reportCompDetail" @afterSave="queryConfigList" @close="close"></report-comp-detail>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from '@/apiProvider';
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {hideLoading, showLoading, isEmpty} from '@/utils/util';
  import ReportCompDetail from "@/views/authorization/ReportCompDetail";

  export default {
    mixins: [getAuthOrization],
    components: {ReportCompDetail},
    data() {
      return {
        loading: false,
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100
        },
        tableData: [],
        handleStatus: null,
        visible: false,
        title: '',
      }
    },
    filters: {},
    mounted() {
      this.queryConfigList();
    },
    methods: {
      showEdit(row) {
        this.visible = true;
        this.$refs.reportCompDetail.showEdit(row);
      },
      async queryConfigList() {
        this.loading = true;
        let res = await $api.reportData.get("queryConfigList");
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
          this.page.totalResult = res.data.total;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
      },
      refresh() {

      },
    }
  }
</script>

<style>
</style>